var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOutIcon = function SvgZoomOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "m18.535 16.424-3.15-3.15a7.886 7.886 0 1 0-2.118 2.11l3.158 3.157a1.497 1.497 0 0 0 2.435-.485 1.5 1.5 0 0 0-.325-1.632m-9.66-13.91a6.36 6.36 0 1 1-6.36 6.36 6.37 6.37 0 0 1 6.36-6.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M6.256 9.623h5.238a.748.748 0 0 0 0-1.497H6.256a.748.748 0 1 0 0 1.497"
  })));
};
export { SvgZoomOutIcon as ReactComponent };